import { Button } from "@component/button";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { ClockIcon } from "lucide-react";

interface SubmittedRetakeDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function SubmittedRetakeDialog({
    isOpen,
    onClose,
}: SubmittedRetakeDialogProps) {

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader className="flex flex-col items-center text-center space-y-4 pt-4">
                    <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
                        <ClockIcon className="h-8 w-8 text-amber-500" />
                    </div>
                    <DialogTitle className="text-xl font-semibold">
                        Request Already Submitted
                    </DialogTitle>
                    <p className="text-muted-foreground px-4">
                        You have already submitted a request to retake this interview.
                        Our team is reviewing your request and will respond within 24
                        hours.
                    </p>
                </DialogHeader>

                <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg p-4 my-2">
                    <p className="text-sm text-amber-600 dark:text-amber-400">
                        You can only submit one retake request per interview. <br></br>If you
                        need further assistance, please contact support at support@ourteam.ai.
                    </p>
                </div>

                <DialogFooter>
                    <Button
                        type="button"
                        className="w-full sm:w-auto"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
